module.exports = __webpack_public_path__ + "img/密集架.b47fceda.jpg";